import { AbstractModel } from '@patsnap/tahiti-core';
import type { RetrievalProgressState, RetrievalResult } from '../../types';
import type { FtoReportRetrievalProgressModel } from '../retrieval-progress-model';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { RETRIEVAL_STRATEGY } from '../../constants';

function createInitialRetrievalProgressState(): RetrievalProgressState {
    return {
        timeSpend: 0,
        timeSaved: 0,
        steps: [],
        result: new Map<RETRIEVAL_STRATEGY, RetrievalResult>(),
    };
}

@injectable()
export class FtoReportRetrievalProgressModelImpl extends AbstractModel<RetrievalProgressState> implements FtoReportRetrievalProgressModel {
    protected _modelData: RetrievalProgressState = createInitialRetrievalProgressState();

    dispose(): void {
        this.update(() => createInitialRetrievalProgressState());
    }
}
